import { Scale } from "@pdfking/math"
import { HorizontalAlign } from "@pdfking/renderer-api"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Trixie, a poster calendar: its picture over its head with the year on it, its months four across under it, the contact at its foot. */
export const Trixie: CalendarDesign = {
  cover: PictureCover({}),
  page: ({ body, contact, gap, outer, page, short, year }) => {
    const picture = Region(page, 0, 0.55, 1, 1)
    return [
      Area.titled(
        picture,
        "year",
        Slice.top(outer, Scale(short, 0.08))[0],
        `${year}`,
        HorizontalAlign.LEFT
      ),
      ...Area.months(Slice.under(body, picture.y, gap), year, 4, gap),
      Area.footer(contact),
    ]
  },
  pages: "year",
}
